import AdminInfo from '@/generated/classes/AdminInfo';
export default class AdminInfoExtend extends AdminInfo {
  constructor() {
    super();
  }
}
